import { TextField } from '@/components'
import type { TrialSignUp } from '../../hooks/useTrialSignUp'

type InputChange = React.ChangeEvent<HTMLInputElement>

interface NameFieldsProps {
  form: TrialSignUp['form']
}

export const NameFields = ({ form }: NameFieldsProps) => {
  const { data, errors, setFieldValue } = form
  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
      <TextField
        label="First name"
        id="first-name"
        placeholder="Type your first name"
        autoComplete="given-name"
        value={(data.firstName as string) ?? ''}
        error={errors.firstName}
        onChange={(e: InputChange) =>
          setFieldValue('firstName', e.target.value)
        }
        required
      />
      <TextField
        label="Last name"
        id="last-name"
        placeholder="Type your last name"
        autoComplete="family-name"
        value={(data.lastName as string) ?? ''}
        error={errors.lastName}
        onChange={(e: InputChange) => setFieldValue('lastName', e.target.value)}
        required
      />
    </div>
  )
}
